<template>
  <button
    class="button-toggle"
    :data-off="!state.isVisibleMicSecretController"
    @click="actions.toggleMicSecretController"
  >
    <ToggleSwitch
      :model-value="state.isVisibleMicSecretController"
      @update:modelValue="actions.toggleMicSecretController"
    />
    마이크 컨트롤러 보기
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { DEFAULT_CHAT_UI_STATE } from '@/utils/constants/chat';
import { ij_chat_ui } from '@/utils/injectionKeys';

const { state, actions } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE);
</script>

<style scoped lang="scss"></style>
